import { module } from 'modujs';
import { createApp } from 'vue/dist/vue.esm-bundler.js';

const API_URL = 'https://contact-api.inguest.com/api/add-contacts-to-lists'
const API_TOKEN = 'c9ea8c40-6936-4cf9-bcca-d502361add8e'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

        this.app = createApp({
            delimiters: [ '${', '}' ],
            data: () => ({
                email: '',
                message: '',
            }),
            methods: {
                submit() {
                    this.message = 'Submitting...'

                    fetch(API_URL,
                        {
                            method: 'POST',
                            crossDomain: true,
                            mode: 'no-cors',
                            headers: {
                                'Content-Type': 'text/plain'
                            },
                            body: JSON.stringify({
                                tokens: [
                                    API_TOKEN
                                ],
                                contacts: [
                                    {
                                        email: this.email
                                    }
                                ]
                            })
                        })
                        .then(r => {
                            this.message = 'You were successfully added to our contact list.'

                            setTimeout(() => {
                                this.email = ''
                                this.message = ''
                            }, 5000);
                        })
                        .catch(e => {
                            this.message = 'An error happened, try again.'

                            setTimeout(() => {
                                this.email = ''
                                this.message = ''
                            }, 5000);
                        })
                }
            },
        }).mount(this.el)
    }
}